<template>
  <div>
    <div class="text-justify iha-agreement-text-container" v-if="currentPlan.is_iha">
      <p class="agreement-heading"><strong>Important Information About Changing Your Medical Plan or Network</strong></p>
      <p>
        You currently have the option to change your plan and/or network for a January 1 effective date.
        However, please note the following important details:
      </p>
      <p>
      <ol class="agreement-condition-container">
        <li><strong>1. Rate Guarantee Period</strong></li>
        <li>While you can make changes to your plan or network, the 12-month rate guarantee remains tied to your original effective date. This means the guaranteed rate period does not reset with the January 1 change and will end 12 months from your initial plan start date.</li>
      </ol>
      <ol class="agreement-condition-container">
        <li><strong>2. Understand the Differences</strong></li>
        <li>If switching to a new plan or network, be aware that coverage, costs, and benefits may differ. We strongly recommend reviewing all options to ensure the new plan or network aligns with your needs.</li>
      </ol>
      </p>
      <p>
        If you’re considering making a change, be sure to submit your request by <strong>December 15</strong> for a January 1 effective date. If you have any questions or need guidance, please don’t hesitate to reach out to your representative. Understanding these terms is essential to making an informed decision
      </p>
    </div>
    <div class="text-justify iha-agreement-text-container" v-else>
      <p class="agreement-heading"><strong>Important Information About Changing Your Medical Plan</strong></p>
      <p>
        You have the option to change your medical plan between <strong>November 23 and December 15</strong> for a January 1 effective date.
        If you're considering switching from your current union medical plan to a non-union medical plan, please carefully review the following important details:
      </p>
      <p>
      <ol class="agreement-condition-container">
        <li><strong>1. Approval Is Not Guaranteed</strong></li>
        <li>Switching to a non-union medical plan requires underwriting. This means your application will be reviewed based on specific criteria, such as your health status and other factors.
          Approval is not guaranteed, and there is a possibility that your application may not be accepted.</li>
      </ol>
      <ol class="agreement-condition-container">
        <li><strong>2. Rate Guarantee Period</strong></li>
        <li>If your application is approved, the rates for the non-union medical plan are guaranteed for 12 months only. After this period, rates may be subject to change.</li>
      </ol>
      <ol class="agreement-condition-container">
        <li><strong>3. Understand the Differences</strong></li>
        <li>Non-union medical plans may differ in terms of coverage, costs, and benefits compared to your union medical plan.
          We encourage you to carefully review and compare the options to ensure they meet your needs.</li>
      </ol>
      </p>
      <p>
        This opportunity to change plans is time-sensitive, so please ensure you submit your application before the December 15 deadline. If you have questions or need assistance, don’t hesitate to reach out to your representative. Making an informed decision is key to selecting the best plan for your circumstances.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "IHAPlanChangeAgreementText",
  props: {
    currentPlan: {
      type: Object
    }
  }
}
</script>

<style scoped>
.iha-agreement-text-container {
  border: 1px solid #dee2e6;
  border-radius: 7px;
  padding: 12px 14px;
  font-size: 15px;
}
.iha-agreement-text-container .agreement-condition-container {
  margin-left: -21px;
}

.iha-agreement-text-container .agreement-heading {
  font-size: 16px;
  margin-top: 10px;
}
</style>